import React, { PropsWithChildren, createContext, useMemo } from 'react'

interface DestinationOfferListAbTestState {
  isDestinationPage?: boolean;
}
export const DestinationOfferListAbTestContext = createContext<DestinationOfferListAbTestState>({})

interface Props {
  sourceType: 'destination-product'
}

function DestinationOfferListAbTestProvider(props: PropsWithChildren<Props>) {
  const { children, sourceType } = props
  const destinationOfferListAbTestState = useMemo<DestinationOfferListAbTestState>(() => {
    return {
      isDestinationPage: sourceType === 'destination-product',
    }
  }, [sourceType])
  return <DestinationOfferListAbTestContext.Provider value={destinationOfferListAbTestState}>
    {children}
  </DestinationOfferListAbTestContext.Provider>
}

export default DestinationOfferListAbTestProvider
